// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useMemo, useEffect, Fragment,
    useState} from 'react';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import Icon_chevron_down from '../img/svg/icon/chevron_down.svg';
import {Select} from '../lib/select';
import {Link} from '../ui/link';
import {Svg_img} from '../ui/svg_img';
import {use_translation_v} from '../lib/trans_v';
import {useHistory} from 'react-router-dom';
import {use_screen} from '../lib/screen_util';
import {use_countries} from '../ui/forms/use_countries';
import zcountry from 'zcountry';
import {perr_www_visit} from 'hola_pub_util';
import {hola_countries} from 'hola_opt';
import cn from 'classnames';
import styles from './explore_network.module.less';

const regions = [
    'Europe', 'North America', 'Latin America', 'Asia', 'Africa', 'Oceania'];

const get_connection = (type = null, nr_connection = 0, prev_connection = 0)=>{
    const robust_cond = type=='agents' ? 10 : 100;
    if (nr_connection > robust_cond)
        return <Svg_img id={'svg/icon/robust_connection.svg'} w={24} h={24}/>;
    if (nr_connection > 0)
        return <Svg_img id={'svg/icon/online.svg'} w={24} h={24}/>;
    if (prev_connection > 0)
    {
        return <Svg_img id={'svg/icon/temporarily_unavailable.svg'}
          w={24} h={24}/>;
    }
    return <Svg_img id={'svg/icon/unavailable.svg'} w={24} h={24}/>;
};

interface I_faq_quest_props {
    quest: string;
    ans: JSX.Element;
    cls?: {
        title?: string,
        text?: string
    };
    scrollable?: boolean;
}
const Faq_question = (props: I_faq_quest_props)=>{
    const {theme} = useContext(Settings_context);
    const [opened, set_opened] = useState(false);
    return <div className={cn(styles.faq_item, opened && styles.opened,
      props.cls && props.cls.title)}>
      <div className={cn(styles.title_line)} onClick={()=>{
        set_opened(!opened);
      }}>
        <p className={cn([theme.p1, theme.med, styles.quest])}>
          {props.quest}</p>
        <Icon_chevron_down/>
      </div>
      <div className={cn(styles.faq_text, props.cls && props.cls.text,
        props.scrollable && styles.scroll)}>
        <div className={cn(theme.p3)}>{props.ans}</div>
      </div>
    </div>;
};

const Legend = ()=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.legend_wrapper}>
      <div className={styles.legend_item}>
        <Svg_img id={'svg/icon/robust_connection.svg'} />
        <p className={cn(theme.p4, theme.reg, theme.color_n600)}>
          - Robust Connection</p>
      </div>
      <div className={styles.legend_item}>
        <Svg_img id={'svg/icon/online.svg'} />
        <p className={cn(theme.p4, theme.reg, theme.color_n600)}>
          - Online</p>
      </div>
      <div className={styles.legend_item}>
        <Svg_img id={'svg/icon/temporarily_unavailable.svg'} />
        <p className={cn(theme.p4, theme.reg, theme.color_n600)}>
          - Temporarily Unavailable</p>
      </div>
      <div className={styles.legend_item}>
        <Svg_img id={'svg/icon/unavailable.svg'} />
        <p className={cn(theme.p4, theme.reg, theme.color_n600)}>
          - Unavailable</p>
      </div>
    </div>;
};

interface i_explore_network_props {
    title?: string;
    subtitle?: string;
}

export const Explore_network = (props: i_explore_network_props)=>{
    const _subtitle = 'With servers and peers in every continent, '
        +'Hola VPN ensures global connectivity and blazing-fast speeds.';
    const {title = 'Explore 190+ VPN Locations for Fast Connections',
        subtitle = _subtitle} = props;
    const {theme} = useContext(Settings_context);
    const {countries} = use_countries('f32', cn(styles.locations_flag_wrap,
        theme.xs, theme.P), styles.locations_flag_icon, null, null, true);
    useEffect(()=>{
        perr_www_visit({id: 'www_locations_visit'});
    }, []);
    const data = useMemo(()=>countries.map(el=>{
        let _title = el.title;
        if (el.value=='GB')
            _title = 'United Kingdom';
        return {
            ...el,
            title: _title,
            c_name: zcountry.code2hiphen_label(el.value),
            agents: hola_countries?.agents &&
                hola_countries?.agents[el.value]||0,
            prev_agents: hola_countries?.prev_data?.agents &&
                hola_countries?.prev_data?.agents[el.value]||0,
            peers: hola_countries?.user_connected &&
                hola_countries?.user_connected[el.value]||0,
            prev_peers: hola_countries?.prev_data?.user_connected &&
                hola_countries?.prev_data?.user_connected[el.value]||0
        };
    }).filter(c=>!['RU', 'IN'].includes(c.value)), []);
    const {t} = use_translation_v();
    const history = useHistory();
    const [query, set_query] = useState('');
    const on_select = (name, value)=>{
        if (!value)
            return;
        history.push('/vpn/'+ zcountry.code2hiphen_label(value));
    };
    const region_countries = useMemo(()=>{
      const regionMap= {};
      regions.forEach(region=>{
          regionMap[region] = [];
      });
      data.map(countryObj=>{
        const possible_regions = zcountry.regions[countryObj.value];
        possible_regions?.map(r=>{
            if (regionMap[r])
                regionMap[r].push(countryObj);
            if (r=='South America')
                regionMap['Latin America'].push(countryObj);
            if (r=='Northern America')
                regionMap['North America'].push(countryObj);
        });
      });
      return regionMap;
    }, []);
    const countries_with_agents_data = useMemo(()=>{
        return data.map(c=>{
            return {
              ...c,
              rendered_item: <div className={styles.search_flag_wrap}>
                  <div className={styles.search_flag_wrap}>
                    <div>{c.rendered_item}</div>
                    <p className={cn(theme.p1, theme.reg, theme.color_n700)}>
                      {c.title}</p>
                  </div>
                  <div className={styles.search_flag_wrap_data}>
                    <p className={cn(theme.p3, theme.reg, theme.color_n600)}>
                      {t('locations_lobby.explore.servers')}<span
                        className={cn(theme.p3, theme.bold)}>
                        {get_connection('agents', c.agents, c.prev_agents)}
                        </span>
                    </p>
                    <p className={cn(theme.p3, theme.reg, theme.color_n600)}>
                      {t('locations_lobby.explore.peers')}<span
                        className={cn(theme.p3, theme.bold)}>
                        {get_connection('peers', c.peers, c.prev_peers)}
                        </span>
                    </p>
                  </div>
              </div>
            };
      }).filter(el=>el.agents>0 || el.peers>0)
          .filter(el=>query ? el.title.toLowerCase().includes(query) : true);
    }, [query]);
    const dropdown_cls = {
        title: styles.region_dropdown,
        text: styles.region_dropdown_text
    };
    const {is_client, width} = use_screen();
    return <div className={cn(theme.container, styles.explore_network)}>
      <div className={styles.title}>
        <h3 className={cn(is_client && width > 1024 ? theme.H3 :
          styles.header_mobile, theme.color_n700)}>
            {title}
        </h3>
        <p className={cn(theme.u3, theme.color_n600)}>
          {subtitle}
        </p>
      </div>
      <Select on_select={on_select}
        on_filter_changed={(name, filter)=>set_query(filter)}
        name="country"
        tag_style={true}
        value={query}
        icon={query ? <Svg_img id={'svg/icon/ic-x.svg'} w={24} h={24}
          on_click={()=>set_query('')} /> :
          <Svg_img id={'svg/icon/search_grey.svg'} w={24} h={24} />}
        title={t('locations_lobby.explore.search')}
        items={countries_with_agents_data}
        class_name={styles.select}/>
      <Legend />
      {regions.map((region, key)=>
        <Faq_question key={key} scrollable={true} cls={dropdown_cls}
          quest={`${region} VPN`}
          ans={<Fragment>
            <div className={styles.region_wrapper}>
              {region_countries[region].map((c, i)=>{
                if (c.agents==0 && c.peers==0)
                  return '';
                return <Link key={i} to={'https://hola.org/vpn/'
                  +c.value.toLowerCase()}>
                  <div key={i} className={styles.regions_flag_wrap}>
                    <div className={styles.flag}>{c.rendered_item}</div>
                    <div>
                      <p className={cn(theme.p3, theme.med,
                        theme.color_n700, styles.country_title)}>
                        {c.title}</p>
                      <div className={cn(styles.top_description,
                        styles.top_description_values)}>
                        <p className={cn(theme.p3, theme.reg,
                          theme.color_n600)}>
                          {t('locations_lobby.explore.servers')}<span
                            className={cn(theme.p3, theme.bold)}>
                            {get_connection('agents', c.agents, c.prev_agents)}
                            </span></p>
                        <p className={cn(theme.p3, theme.reg,
                          theme.color_n600)}>
                          {t('locations_lobby.explore.peers')}<span
                            className={cn(theme.p3, theme.bold)}>
                            {get_connection('peers', c.peers, c.prev_peers)}
                            </span></p>
                      </div>
                      </div>
                    </div>
                </Link>;
              })}
            </div>
          </Fragment>} />)}
    </div>;
};

interface i_explore_network_editor_props {
    value: i_explore_network_props;
    on_change: (new_val: i_explore_network_props)=>void;
}

export const Explore_network_editor = (
{value, on_change}: i_explore_network_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'title', type: 'text', label: 'Title'},
        {key: 'subtitle', type: 'text', label: 'Subtitle'}
      ]}/>;
};
